<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 210px'>
        <p>供应商：</p>
        <el-input v-model='nameIpt' size='mini' style='width:150px' placeholder='请输入供应商' />
      </div>
      <div class='navContainer'>
        <p>状态：</p>
        <el-select v-model='areaIpt' filterable size='mini' style='width:150px' placeholder='请选择'>
          <el-option v-for='item in areaOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div class='tableContainerNav'>
          <span @click='exportClick' style='cursor:pointer;font-size: 16px;'>导出数据</span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px'>
            <div slot-scope='scope'>{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop='name' label='供应商名称' align='center' />
          <el-table-column prop='account' label='登录账号' align='center' />
          <el-table-column prop='address' label='详细地址' align='center' />
          <el-table-column prop='shipCount' label='船舶数量' align='center' />
          <!-- <el-table-column prop="account" label="登录账号" align="center"/> -->
          <el-table-column label='状态' align='center'>
            <div slot-scope='scope'>{{ getState(scope.row.isEnable) }}</div>
          </el-table-column>
          <el-table-column label='操作' width='210' align='center'>
            <template slot-scope='scope'>
              <div>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id)'>详情
                </el-button>
                <el-button v-if='scope.row.isEnable' size='mini' type='danger'
                           @click='disableClick(scope.row.id)'>禁用
                </el-button>
                <el-button v-else size='mini' type='primary' @click='enableClick(scope.row.id)'>启用
                </el-button>
                <el-button size='mini' type='primary' @click='changeClick(scope.row)'
                           class='yellow-bg'>修改
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情委托商类型' :visible.sync='detailDialogVisible' width='550px' center>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ detailData.state }}</p>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>供应商全称：</span>
              <span>{{ detailData.name }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>供应商简称：</span>
              <span>{{ detailData.shortName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>关键词：</span>
              <span>{{ detailData.keyWord }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>详细地址：</span>
              <span>{{ detailData.address }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>邮箱：</span>
                <span>{{ detailData.email }}</span>
              </div>
              <div>
                <span class='span1'>电话：</span>
                <span>{{ detailData.phone }}</span>
              </div>
            </div>
            <div v-for='(item,index) in detailData.person' :key='index'>
              <div class='baseInfoContentItem specialItem'>
                <div class='specialOne'>
                  <span class='span1'>对接人姓名：</span>
                  <span>{{ item.name }}</span>
                </div>
                <div>
                  <span class='span1'>对接人电话：</span>
                  <span>{{ item.tell }}</span>
                </div>
              </div>
              <div class='baseInfoContentItem'>
                <span class='span1'>对接人职位：</span>
                <span>{{ item.position }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>物流属性：</span>
              <span>{{ detailData.logisticsAttribute!=null?(detailData.logisticsAttribute==0?'民生':'非民生'):'' }}</span>
            </div>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>操作信息</span>
          </div>
          <div class='operationTable'>
            <el-table :data='operationData' border>
              <el-table-column label='操作时间' align='center' width='160px'>
                <div slot-scope='scope'>{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop='operateType' label='操作类型' align='center' />
              <el-table-column prop='operationName' label='操作人' align='center' />
              <el-table-column prop='remark' label='备注' align='center' />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='600px' center
               @close='dialogClose' :close-on-click-modal='false'>
      <div class='company'>
        <el-form :model='companyData' label-width='95px' :rules='rules' ref='ruleForm'>
          <div-border label='基础信息'>
            <el-row>
              <el-col v-if="dialogTitle=='添加水路供应商'">
                <el-form-item label='登录账号：' prop='account' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.account'
                    placeholder='请输入登录账号(手机号)'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col v-if="dialogTitle=='添加水路供应商'">
                <el-form-item label='登录密码：' prop='password' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.password'
                    placeholder='请输入登录密码'
                    autocomplete='off'
                    size='small'
                    show-password
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='供应商全称：' prop='name' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.name'
                    placeholder='请输入供应商全称'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='供应商简称：' prop='referred' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.referred'
                    placeholder='请输入供应商简称'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='关键词：' prop='keyword' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.keyword'
                    placeholder='请输入关键词'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='详情地址：' prop='address' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.address'
                    placeholder='请输入详情地址'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='物流属性：' style='margin-top: 15px'>
                  <el-radio-group v-model='companyData.logisticsAttribute'>
                    <el-radio :label='0'>民生</el-radio>
                    <el-radio :label='1'>非民生</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='邮箱：' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.mail'
                    placeholder='请输入邮箱'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='电话：' style='margin-top: 15px'>
                  <el-input
                    :style="'width:100%'"
                    v-model='companyData.tell'
                    placeholder='请输入电话'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <div v-for='(item,index) in companyData.person' :key='index'>
                <el-col :span='12'>
                  <el-form-item label='对接人姓名：' :prop='`person.${index}.name`' :rules='rules.name'
                                style='margin-bottom: 15px'>
                    <el-input
                      :style="'width:100%'"
                      v-model='item.name'
                      placeholder='请输入对接人姓名'
                      autocomplete='off'
                      size='small'
                    />
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item label='对接人电话：' :prop='`person.${index}.tell`' :rules='rules.tell'>
                    <el-input
                      :style="'width:100%'"
                      v-model='item.tell'
                      placeholder='请输入对接人电话'
                      autocomplete='off'
                      size='small'
                    />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label='对接人职位：' :prop='`person.${index}.position`'
                                :rules='rules.position' style='margin-bottom: 17px'>
                    <div style='display:flex;align-items:center;'>
                      <el-input
                        :style="'width:40%'"
                        v-model='item.position'
                        placeholder='请输入对接人职位'
                        autocomplete='off'
                        size='small'
                      />
                      <div style='display:flex;align-items:center;margin-left: 25px;'
                           v-if='index===companyData.person.length-1'>
                        <el-button
                          style='margin-left: 10px;height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;'
                          size='mini'
                          type='info'
                          icon='el-icon-plus'
                          circle
                          @click='levelAdd'
                        />
                        <el-button
                          v-if='companyData.person.length!==1'
                          style='height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;'
                          size='mini'
                          type='info'
                          icon='el-icon-minus'
                          circle
                          @click='levelMinus'
                        />
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
          </div-border>
          <div class='btnContainer'>
            <el-button class='searchBtn' size='medium' :loading='addLoad' @click='addClick'>确认
            </el-button>
            <el-button class='resetBtn' size='medium' @click='dialogClose'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import { add, detail, isEnable, pageList, update } from '@/service/basicfile';
  import { formatDateTime, getSessionStore, removeSpace } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      divBorder,
    },
    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入对接人联系手机号'));
        } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      const validateAccount = (rule, value, callback) => {
        if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          callback(new Error('请输入正确登录账号'));
        } else {
          callback();
        }
      };
      return {
        nameIpt: '',
        areaIpt: '',
        areaOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '启用中',
          },
          {
            value: 0,
            label: '禁用中',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        operationData: [],
        dialogTitle: '',
        dialogVisible: false,
        addLoad: false,
        companyData: {
          account: '',
          password: '',
          name: '',
          referred: '',
          keyword: '',
          address: '',
          mail: '',
          tell: '',
          logisticsAttribute: 0,
          person: [
            {
              name: '',
              tell: '',
              position: '',
            },
          ],
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入供应商全称',
              trigger: 'blur',
            },
          ],
          account: [
            {
              required: true,
              message: '请输入登录账号',
              trigger: 'blur',
            },
            {
              required: true,
              validator: validateAccount,
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              message: '请输入登录密码',
              trigger: 'blur',
            },
          ],
          referred: [
            {
              required: true,
              message: '请输入供应商简称',
              trigger: 'blur',
            },
          ],
          keyword: [
            {
              required: true,
              message: '请输入供应商关键词',
              trigger: 'blur',
            },
          ],
          address: [
            {
              required: true,
              message: '请输入详情地址',
              trigger: 'blur',
            },
          ],
          name2: [
            {
              required: true,
              message: '请输入对接人姓名',
              trigger: 'blur',
            },
          ],
          tell: [
            {
              required: true,
              validator: validateTell,
              trigger: 'blur',
            },
          ],
          position: [
            {
              required: true,
              message: '请输入对接人职位',
              trigger: 'blur',
            },
          ],
        },
      };
    },
    mounted() {
      this._waterWayDoc();
    },
    computed: {
      getState() {
        return function(state) {
          switch (state) {
            case 1:
              return '启用中';
            case 0:
              return '禁用中';
          }
        };
      },
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
    },
    methods: {
      async _waterWayDoc() {
        this.tableLoad = true;
        const obj = {
          name: this.nameIpt,
          isEnable: this.areaIpt,
          rows: this.size,
          page: this.page,
        };
        const res = await pageList(obj);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._waterWayDoc();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._waterWayDoc();
      },
      levelMinus() {
        this.companyData.person.pop();
      },
      levelAdd() {
        this.companyData.person.push({
          name: '',
          tell: '',
          position: '',
        });
      },
      disableClick(id) {
        this.$confirm('确定要禁用当前委托商吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await isEnable(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._waterWayDoc();
          })
          .catch(() => {
          });
      },
      async detailClick(id) {
        const res = await detail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        const nameArr = res.data.callName.split(',');
        const tellArr = res.data.callPhone.split(',');
        const positionArr = res.data.callPosition.split(',');
        const personArr = [];
        for (let i = 0; i < nameArr.length; i++) {
          personArr.push({
            name: nameArr[i],
            tell: tellArr[i],
            position: positionArr[i],
          });
        }
        this.detailData = {
          ...res.data,
          person: personArr,
        };
        this.operationData = res.data.operateRecordList;
        this.detailDialogVisible = true;
      },
      changeClick(item) {
        const nameArr = item.callName.split(',');
        const tellArr = item.callPhone.split(',');
        const positionArr = item.callPosition.split(',');
        const personArr = [];
        for (let i = 0; i < nameArr.length; i++) {
          personArr.push({
            name: nameArr[i],
            tell: tellArr[i],
            position: positionArr[i],
          });
        }
        this.companyData = {
          ...item,
          referred: item.shortName,
          keyword: item.keyWord,
          address: item.address,
          mail: item.email,
          tell: item.phone,
          person: personArr,
        };
        this.dialogTitle = '修改水路供应商';
        this.dialogVisible = true;
      },
      searchBtn() {
        this.page = 1;
        this._waterWayDoc();
      },
      resetBtn() {
        this.nameIpt = '';
        this.areaIpt = '';
      },
      exportClick() {
        // let token = getSessionStore('token');
        // window.location.href = baseUrl + '/platform/waterSupplier/export?access_token=' +
        //   token + '&name=' + this.nameIpt + '&isEnable=' + this.areaIpt
        //   + '&rows=' + this.size + '&page=' + this.page;
        window.exportExcelGet('/platform/waterSupplier/export', 'name=' + this.nameIpt + '&isEnable=' + this.areaIpt + '&rows=' + this.size + '&page=' + this.page);
      },
      addBtn() {
        this.dialogTitle = '添加水路供应商';
        this.dialogVisible = true;
        this.companyData = {
          account: '',
          password: '',
          name: '',
          referred: '',
          keyword: '',
          address: '',
          mail: '',
          tell: '',
          logisticsAttribute: 0,
          person: [
            {
              name2: '',
              tell: '',
              position: '',
            },
          ],
        };
      },
      addClick() {
        this.companyData = removeSpace(this.companyData);
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let nameStr = '',
              tellStr = '',
              positionStr = '';
            for (let i = 0; i < this.companyData.person.length; i++) {
              if (i !== this.companyData.person.length - 1) {
                nameStr += this.companyData.person[i].name + ',';
                tellStr += this.companyData.person[i].tell + ',';
                positionStr += this.companyData.person[i].position + ',';
              } else {
                nameStr += this.companyData.person[i].name;
                tellStr += this.companyData.person[i].tell;
                positionStr += this.companyData.person[i].position;
              }
            }
            this.addLoad = true;
            const obj = {
              id: this.companyData.id,
              account: this.companyData.account,
              password: this.companyData.password,
              name: this.companyData.name,
              shortName: this.companyData.referred,
              keyWord: this.companyData.keyword,
              email: this.companyData.mail,
              phone: this.companyData.tell,
              address: this.companyData.address,
              callName: nameStr,
              callPhone: tellStr,
              callPosition: positionStr,
              logisticsAttribute:this.companyData.logisticsAttribute
            };
            const res = this.dialogTitle === '添加水路供应商' ? await add(obj) : await update(obj);
            this.addLoad = false;
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            this.dialogVisible = false;
            await this._waterWayDoc();
          } else {
            return false;
          }
        });
      },
      enableClick(id) {
        this.$confirm('确定要启用当前委托商吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await isEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this._waterWayDoc();
          })
          .catch(() => {
          });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px;
      max-height: 70vh;
      overflow: auto;

      .unitContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 140px;
        margin-bottom: 5px;

        ::v-deep {
          .el-input__inner {
            border: 1px solid #DCDFE6;
          }
        }
      }

      .unitContainer2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 189px;
        margin-bottom: 5px;

        span {
          color: #606266;
          font-weight: 700;
        }

        ::v-deep {
          .el-input__inner {
            border: 1px solid #DCDFE6;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }

        .el-form-item {
          margin-bottom: 0;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
